import { render } from "./FavoriteBybit.vue?vue&type=template&id=c512f78c"
import script from "./FavoriteBybit.vue?vue&type=script&lang=js"
export * from "./FavoriteBybit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__